"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const core_1 = require("@emotion/core");
const styled_react_1 = require("./styled-react");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Banner = ({ className, backgroundColor, borderWidth, borderColor, borderRadius, width, icon, iconBackground, iconBorderRadius, title, description, }) => (core_1.jsx("div", { className: className, css: styled_react_1.bannerContainerDynamicStyle(borderRadius, backgroundColor, `${borderWidth} solid ${borderColor}`, width) },
    icon && (core_1.jsx("div", { className: styles_scss_1.default.iconContainer },
        core_1.jsx("div", { css: styled_react_1.iconBoxDynamicStyle(iconBackground, iconBorderRadius) },
            core_1.jsx("img", { className: styles_scss_1.default.icon, src: icon, alt: "banner-icon" })))),
    core_1.jsx("div", { className: styles_scss_1.default.infoContainer },
        core_1.jsx("p", { className: styles_scss_1.default.title }, title),
        core_1.jsx("p", { className: styles_scss_1.default.description }, description))));
Banner.defaultProps = {
    backgroundColor: undefined,
    borderWidth: '0px',
    borderColor: undefined,
    borderRadius: '0px',
    icon: undefined,
    iconBackground: undefined,
    iconBorderRadius: undefined,
    title: undefined,
    description: undefined,
    width: undefined,
    className: '',
};
exports.default = Banner;
